import styled from 'styled-components';
import Cards from 'components/Core/Cards';

export const CardContainer = styled.div`
  .ant-radio-button-wrapper {
    width: 100%;
    height: 54px;
    padding: 15px 10px;
    background: var(--gray-1);
    border: none;
    & > span:last-child {
      display: flex;
    }
    &:hover {
      background-color: #4f4f4f;
    }
    &:focus-within {
      box-shadow: none;
    }
    .resource-switch--icon-container {
      margin-right: 5px;
      width: 30px;
      display: inline-block;
      img {
        vertical-align: sub;
        max-height: 24px;
      }
    }
  }
  @media (max-width: 576px) {
    .slick-slider {
      .slick-slide > div {
        margin: 0px 5px;
      }
      &:before {
        position: absolute;
        left: -20px;
        content: ' ';
        width: 50px;
        height: 100%;
        background: ${props =>
          `linear-gradient(to right, ${props.background}ff, ${props.background}00),
          linear-gradient(to right, ${props.background}ff, 80%, ${props.background}00)`};
        z-index: 1;
        pointer-events: none;
      }

      &:after {
        position: absolute;
        right: -20px;
        content: ' ';
        width: 50px;
        height: 100%;
        background: ${props =>
          `linear-gradient(to left, ${props.background}ff, ${props.background}00),
          linear-gradient(to left, ${props.background}ff, 80%, ${props.background}00)`};
        z-index: 1;
        pointer-events: none;
        top: 0;
      }
    }

    .ant-radio-button-wrapper {
      .resource-switch--icon-container {
        vertical-align: sub;
        img {
          max-height: 20px;
        }
      }
    }
  }
  .ant-radio-button-wrapper-checked {
    background-color: var(--gray-dark);
  }
`;

export const StyledCards = styled(Cards)`
  .card--cover {
    background: ${props => props.backgroundColor};
    ${props =>
      props.backgroundColor
        ? `padding-top: 63.25%;
      .card--cover-wrapper {
        padding: 20px;
      }`
        : ''};
  }
  .cards-blog--title {
    line-height: 1em;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }
`;
